import axiosClient from './axiosClient';
import { AUTH_ENDPOINTS } from './api_endpoints';

const authApi = {
  loginAdminEmail: async (payload) => {
    const response = await axiosClient.post(AUTH_ENDPOINTS.LOGIN_ADMIN_EMAIL, payload);
    return { body: response.data, status: response.status };
  },

  refreshAdmin: async () => {
    const response = await axiosClient.post(AUTH_ENDPOINTS.REFRESH_ADMIN, {});
    return { body: response.data, status: response.status };
  },

  refreshRecruiter: async () => {
    const response = await axiosClient.post(AUTH_ENDPOINTS.REFRESH_RECRUITER, {});
    return { body: response.data, status: response.status };
  },

  getMeAdmin: async () => {
    const response = await axiosClient.get(AUTH_ENDPOINTS.ME_ADMIN);
    return { body: response.data, status: response.status };
  },

  logoutAdmin: async () => {
    const response = await axiosClient.post(AUTH_ENDPOINTS.LOGOUT_ADMIN, {});
    return { body: response.data, status: response.status };
  },
};

export default authApi;
